export const WIDGET_MICRO_APP_TYPE = 'micro-app';

export const SCOPE = 'micro-app-widget';
